import { SignupPage } from './../../pages/signup';

export const SignupView = () => {
  return (
    <>
      <SignupPage />
    </>
  );
};
